/**
 * Согласование GeoJSON с выбранным в KLS типом примитива (Multi*).
 * Нативное рисование отдаёт Point / LineString / Polygon — при выборе Multi* в диалоге
 * бэкенд поднимает тип; здесь то же для поля type и для initial_geometry на клиенте.
 */

import { normalizePrimitiveCode } from "@/lib/map-geometry-tools";

export function alignGeoJsonToPrimitiveCode(
  geojsonInput: GeoJSON.Feature | GeoJSON.Geometry,
  primitiveCode: string | null | undefined,
): { geojson: GeoJSON.Feature | GeoJSON.Geometry; geometryTypeLower: string } {
  const prim = normalizePrimitiveCode(primitiveCode || "");
  const isFeature =
    geojsonInput &&
    typeof geojsonInput === "object" &&
    (geojsonInput as GeoJSON.GeoJsonObject).type === "Feature";
  const feature = isFeature ? (geojsonInput as GeoJSON.Feature) : null;
  const geom = feature?.geometry ?? (geojsonInput as GeoJSON.Geometry);

  if (!geom || typeof geom !== "object" || !("type" in geom) || !geom.type) {
    return {
      geojson: geojsonInput,
      geometryTypeLower: "polygon",
    };
  }

  const gt = String(geom.type).toLowerCase();
  let newGeom: GeoJSON.Geometry = geom;

  if (prim === "multipolygon" && gt === "polygon" && "coordinates" in geom) {
    newGeom = {
      type: "MultiPolygon",
      coordinates: [(geom as GeoJSON.Polygon).coordinates],
    };
  } else if (prim === "multilinestring" && gt === "linestring" && "coordinates" in geom) {
    newGeom = {
      type: "MultiLineString",
      coordinates: [(geom as GeoJSON.LineString).coordinates],
    };
  } else if (prim === "multipoint" && gt === "point" && "coordinates" in geom) {
    newGeom = {
      type: "MultiPoint",
      coordinates: [(geom as GeoJSON.Point).coordinates],
    };
  }

  const out: GeoJSON.Feature | GeoJSON.Geometry = feature
    ? { ...feature, geometry: newGeom }
    : newGeom;

  return {
    geojson: out,
    geometryTypeLower: String(newGeom.type).toLowerCase(),
  };
}
